import { FormCount } from './formCount';
import { changeSelectColor } from '../changeSelectColor';
import { DoubleForm } from '../doubleForm';

const addButton = document.querySelectorAll('.js-form-add');

addButton.forEach((button) => {
  button.addEventListener('click', () => {
    const targetForm: string = (button as HTMLElement).dataset.target as string;
    const addElm: HTMLElement = document.querySelector(
      `.${targetForm}`
    ) as HTMLElement;
    console.dir(addElm);
    const clone: HTMLElement = addElm.cloneNode(true) as HTMLElement;
    clone.classList.add("p-form__add");
    if (clone.querySelector("select")) {
      (clone.querySelector('select') as HTMLElement).addEventListener("change", ()=>{
        changeSelectColor((clone.querySelector('select') as HTMLSelectElement)); 
      });
      (clone.querySelector('select') as HTMLElement).addEventListener("load", ()=>{
        changeSelectColor((clone.querySelector('select') as HTMLSelectElement)); 
      });
    }
    if (clone.classList.contains("js-form-double-select")) {
      DoubleForm(clone as HTMLElement);
    }
    (clone.querySelector('.js-form-delete') as HTMLElement).addEventListener(
      'click',
      () => {
        clone.remove();
        FormCount();
      }
    );
    const area: HTMLElement = document.querySelector(
      `.${targetForm}-area`
    ) as HTMLElement;
    if (addElm) {
      area.appendChild(clone);
    }
    FormCount();
  });
  
});
